import React from 'react'
import { Notification } from '../../../common/notification'
import { COMPANY_TYPES } from '../../../utils/common'
import { Layout } from '../../Layout'
import { CompanyInfo } from '../../common/header/companyInfo'
import useCheckIsCompanyType from '../../common/header/companyInfo/useCheckIsCompanyType'
import { StandardComponent } from './standardUser'

const StandardComponentScore = () => {
  const isUnavailable = useCheckIsCompanyType([
    COMPANY_TYPES.FUNDS,
    COMPANY_TYPES.INSURANCE,
    COMPANY_TYPES.NON_BANK,
    COMPANY_TYPES.BANK,
    COMPANY_TYPES.SECURITIES,
    COMPANY_TYPES.LIFE_INSURANCE,
    COMPANY_TYPES.NON_LIFE_INSURANCE,
  ])

  return (
    <Layout
      renderTopComponent={() => <CompanyInfo />}
      renderStickyComponent={() => <></>}
      renderBottomComponent={() =>
        isUnavailable ? (
          <Notification
            isI18n
            value="errorCommon.COMPANY_TYPE_ERROR"
            style={{ fontSize: 20 }}
          />
        ) : (
          <StandardComponent />
        )
      }
      isShowFooter={false}
    />
  )
}

export default StandardComponentScore
